import React from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import * as PropTypes from 'prop-types'
import { Box, Button, Chip, Grid } from '@material-ui/core'
import clsx from 'clsx'
import { GRAY_COLORS } from 'asterX-UI/colors.constant'

const StyledTableCell = withStyles(theme => ({
  root: {
    position: 'static'
  },
  head: {
    backgroundColor: 'transparent',
    color: GRAY_COLORS[600],
    padding: '12px',
    whiteSpace: 'nowrap',
    '&:first-child': {
      paddingLeft: '24px'
    }
  },
  body: {
    color: GRAY_COLORS[600],
    padding: '12px',
    fontSize: 14,
    fontWeight: 500,
    '&:first-child': {
      paddingLeft: '24px'
    }
  }
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
  root: {
    position: 'relative',
    padding: '12px',
    '&:nth-child(odd)': {
      backgroundColor: GRAY_COLORS[50]
    },
    cursor: props => {
      if (props?.clickable) {
        return 'pointer'
      }

      return 'default'
    },
    '&:hover': {
      backgroundColor: props => {
        if (props?.clickable) {
          return GRAY_COLORS[50]
        }

        return ''
      }
    }
  }
}))(TableRow)

const useStyles = makeStyles(theme => ({
  tableContainer: {
    boxShadow: 'unset',
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 12,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  bgClick: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    opacity: 0
  },
  table: {
    minWidth: 700,
    [theme.breakpoints.down('md')]: {
      minWidth: 935
    }
  },
  tableHead: {
    backgroundColor: 'transparent'
  }
}))

export default function StandardTable({
  tableData,
  tableStyles,
  onRowClick,
  hasBackgroudRowClick = false,
  onButtonClick,
  onChipClick,
  btnColor = 'primary',
  btnVariant = 'outlined',
  btnStyle = {},
  className
}) {
  const classes = useStyles()

  return (
    <TableContainer className={clsx(classes.tableContainer, className)} component={Paper} style={tableStyles}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead className={classes.tableHead}>
          <TableRow>
            {tableData?.columns?.map((name, index) => (
              <StyledTableCell key={`styled_name_${index}`}>{name}</StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.rows.map((row, index) => {
            const rowData = Array.isArray(row) ? row : row.values
            const rowStyle = row?.style || {}

            return (
              <StyledTableRow
                key={`styled_row_${index}`}
                clickable={!!onRowClick}
                onClick={() => !hasBackgroudRowClick && onRowClick?.(rowData)}
                style={rowStyle}
              >
                {rowData.map((val, indx) => (
                  <StyledTableCell key={`styled_cell_${indx}`}>
                    {hasBackgroudRowClick && <Box className={classes.bgClick} onClick={() => onRowClick?.(rowData)} />}
                    {val?.label ? (
                      <Grid container spacing={1} justifyContent={val?.isButton ? 'flex-end' : 'flex-start'}>
                        <Grid item>
                          {val?.isButton && (
                            <Button
                              size="small"
                              color={btnColor}
                              variant={btnVariant}
                              style={{ ...btnStyle, ...(val?.style || {}) }}
                              onClick={() => onButtonClick?.(val?.data ? val?.data : rowData)}
                            >
                              {val?.label}
                            </Button>
                          )}

                          {val?.isChip && (
                            <Chip
                              label={val?.label}
                              style={{ ...btnStyle, ...(val?.style || {}) }}
                              onClick={() => onChipClick?.(val?.data, rowData)}
                            />
                          )}
                        </Grid>
                      </Grid>
                    ) : (
                      val
                    )}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
StandardTable.propTypes = {
  tableData: PropTypes.shape({
    columns: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired
  }).isRequired
}
